export type EscapeDismissible = { close: () => void }

// 열려 있는 dismissible 들. Escape 한 번에 중첩된 것들이 한꺼번에 닫히면 안 되므로
// 스택으로 관리하고 최상단(가장 나중에 열린) 하나만 이벤트를 소비한다.
let stack: readonly EscapeDismissible[] = []

// react-modal 은 key 가 아니라 code·keyCode 로 Escape 를 판정한다(isEscKey).
// 어느 쪽만 채워진 이벤트에서도 우리가 먼저 소비해야, dismissible 은 그대로인데
// 상위 모달만 닫히는 비대칭이 생기지 않는다.
const isEscape = (event: KeyboardEvent) =>
  event.key === 'Escape' || event.code === 'Escape' || event.keyCode === 27

const handleEscape = (event: KeyboardEvent) => {
  if (!isEscape(event)) return

  const top = stack[stack.length - 1]
  if (!top) return

  // 한글 조합 중 Escape 는 조합 취소 의도이므로 dismiss 하지 않는다. 다만 전파는 끊어야
  // 상위 모달이 대신 닫히지 않는다 — preventDefault 는 하지 않아 IME 의 조합 취소는 살린다.
  if (event.isComposing) {
    event.stopPropagation()
    return
  }

  top.close()
  // capture 단계에서 전파를 끊어야 같은 Escape 가 상위 모달(react-modal 의 shouldCloseOnEsc)까지
  // 닫는 것을 막을 수 있다. React 는 루트 컨테이너에 리스너를 붙이므로 document capture 가 앞선다.
  event.stopPropagation()
}

export const pushEscapeDismiss = (entry: EscapeDismissible) => {
  if (stack.includes(entry)) return

  if (stack.length === 0) {
    document.addEventListener('keydown', handleEscape, true)
  }
  stack = [...stack, entry]
}

export const popEscapeDismiss = (entry: EscapeDismissible) => {
  if (!stack.includes(entry)) return

  stack = stack.filter((dismissible) => dismissible !== entry)
  if (stack.length === 0) {
    document.removeEventListener('keydown', handleEscape, true)
  }
}
